<template>
  <div class="row">
    <div class="col-md-12 mt-5">
      <div class="row">
        <div class="col-sm-6 col-lg-6  col-md-6">
          <v-btn style="width: 100%" @click="search_by_accession = false; key=null" class="btn"
                 :class="!search_by_accession?'btn-primary text-white':''">Search by student ID
          </v-btn>
        </div>
        <div class="col-sm-6 col-lg-6  col-md-6">
          <v-btn style="width: 100%" @click="search_by_accession = true; key=null" class="btn"
                 :class="search_by_accession?'btn-primary text-white':''">Search by accession No.
          </v-btn>
        </div>
        <div class="col-sm-12 col-lg-12  col-md-12 bg-white rounded">
          <v-text-field
              v-model="key"
              outlined

              dense
              flat
              :label="search_by_accession?'Book accession no':'Student Id'"
              :loading="loading"
              autofocus
              type="text"
              ref="search_field"
              @input="__search()"
              clearable

              @click:clear="clearSearch()"
          >
          </v-text-field>
          <!--          <div class="row">-->
          <!--            <div class="col-12">-->
          <div class="row" v-if="search_by_accession">
            <div class="col-12">
              <div class="card mt-3" style="max-width: 100%">
              <div class="card-header pt-3 pb-3">
                <h4>Found: {{book_accessions.length}}</h4>
              </div>
              <v-list dense >
                <v-list-item-group
                    color="primary"
                >
                  <v-list-item v-show="book_accessions.length > 0"
                      v-for="(accession, i) in book_accessions"
                      :key="i"
                  >
                    <v-list-item-content @click="selectBook(accession)">
                      <v-list-item-title>
                       <span class="font-weight-medium">
                         {{
                            `${accession.accession_no} - ${accession.book_title} ${accession.user_full_name ? "-" + accession.user_full_name : ""}`
                          }}
                          <span class="text-sm badge badge-primary"
                                v-if="!accession.is_available && accession.user_full_name">ISSUED</span>
                          <!--                        <span class="badge badge-primary ml-3" v-if="!usr.enable_library">Membership Expired</span>-->
                        </span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
                <div v-if="book_accessions.length==0" class="text-center">
                       <span class="font-weight-medium " >
                         <strong>Date not available.</strong>
                      </span>
                </div>
              </v-list>
            </div>
            </div>
          </div>

          <!--            </div>-->
          <!--          </div>-->
        </div>
      </div>
      <div class="row search_result_dashboard" v-if="user && user.id && !search_by_accession">
        <div class="col-lg-3 col-md-3 col-sm-3">
          <v-avatar
              v-if="user.image_path && user.image_path['real']"
              class="profile"
              color="grey"
              size="100%"
              tile
          >
            <v-img :src="user.image_path['real']"></v-img>
          </v-avatar>
          <v-avatar
              v-else
              class="profile"
              color="grey"
              size="100%"
              tile
          >
            <v-img
                :src="'://images.unsplash.com/photo-1509114397022-ed747cca3f65?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2550&q=80'"></v-img>
          </v-avatar>

        </div>
        <div class="col-lg-9 col-md-9 col-sm-9">
         <span>
             <h5>
                        {{ user.id_card_no ? user.id_card_no + ' - ' : '' }}
                        {{ user.personal_id ? user.personal_id : '' }}
                      </h5>
           <h5>{{ user.full_name }}</h5>
           <p>
             <span>{{ user.phone }}, {{ user.email }}</span><br>
              <span v-if="user.setting && user.setting.academic_year">{{ user.setting.academic_year }}, </span>
              <span v-if="user.setting && user.setting.program_title">{{ user.setting.program_title }}</span><br>
              <span v-if="user.setting && user.setting.current_semester_title">{{ user.setting.current_semester_title }}
                - {{ user.setting.current_class_title }}
              </span>
           </p>
              <p>Currently issued
              <v-chip color="blue" class="text-white font-weight-bold">{{ user_issue_list.length }}</v-chip></p>
                </span>
        </div>
      </div>
      <return-and-issue-by-book-accession
          :book_accession="book_accession"
          :library_setting="library_setting"
          @refresh="__search"
      ></return-and-issue-by-book-accession>

      <user-issued-book
          v-if="user_issue_list.length>0 && !search_by_accession"
          :type="'currently'"
          :issued_books="user_issue_list"
          :action="true"
          :user="user"
          :library_setting="library_setting"
          @refresh="__search"
      ></user-issued-book>
    </div>
  </div>
</template>

<script>
import IssueService from "@/core/services/library/issue/IssueService";
import BookMixin from "@/mixins/BookMixin";
import UserIssuedBook from "../pages/library/return/UserIssuedList";
import ReturnAndIssueByBookAccession from "@/view/component/IssueRenewAndReturnModal/ReturnAndIssueByBookAccession";
import SettingService from "@/core/services/library/setting/SettingService";

const settingService = new SettingService();
const issueService = new IssueService();

export default {
  name: "ReturnBook",
  mixins: [BookMixin],
  components: {
    UserIssuedBook, ReturnAndIssueByBookAccession
  },
  data() {
    return {
      search_by_accession: false,
      student_detail: {},
      key: null,
      loading: false,
      user: {},
      book_accession: null,
      library_setting: null,
      user_issue_list: [],
      // selected_book: {},
      // selected_user: {},
      // selected_list: [],
      // search: null,
      //
      // key: null,
      // search_user: null,
      // loading: false,
      // users: [],
      // issue_date: null,
    }
  }, watch: {
    search(val) {
      if (val)
        this.searchBook(val)
    },
    search_user(newValue, oldValue) {
      if (newValue)
        this.searchUser({name: newValue})
    },
    current_user() {
      return this.$store.getters.currentUser;
    },
    search_by_accession(val) {
      this.__search()
      this.$refs.search_field.focus();
    },

  },
  mounted() {
    this.issue_date = this.$moment(new Date()).format('DD/MM/YYYY')
    this.getLibrarySetting();
  },
  methods: {
    getLibrarySetting() {
      settingService.first().then(response => {
        if (response.data) {
          this.library_setting = response.data
        }
      })
    },
    __search() {
      if (this.key) {
        if (this.search_by_accession) {
          this.book_accession = {}
          this.searchBookByAccession(this.key);
        } else {
          this.searchByUser();
        }
      } else {
        this.resetSearch()
      }
    },
    resetSearch() {

      this.user = {};
      this.book_accessions = [];
      this.book_accession = {};
      this.library_setting = {};
      this.user_issue_list = [];
    },

    searchByUser() {
      if (!this.key)
        return
      issueService.getByStudentCardId(this.key).then(response => {
        this.student_detail = response.data
        this.user = this.student_detail.user
        this.user_issue_list = this.student_detail.currently_issued
      })
    },
    selectBook(acession) {
      this.book_accession = {}
      this.book_accession = acession
    }
  }
}
</script>

<style scoped>

</style>